<template>
    <td-dialog
        v-dialogDrag
        :title="$t('pgCommon.TIPS')"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="dialogMessageVisible"
        :before-close="messageDialogClose"
        append-to-body="true"
        width="500px"
        top="18vh"
    >
        <el-form :label-position="right" :label-width="formLabelWidth">
            <el-form-item :label="$t('pgCommon.FAIL_INFO')">
                <div v-html="statusMessage"></div>
            </el-form-item>
            <el-form-item v-show="content" :label="$t('pgCommon.FAIL_REASON')">
                <div v-html="content"></div>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button @click="messageDialogClose">{{ $t('pgCommon.CLOSE') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
export default {
    props: ['dialogMessageVisible', 'content', 'statusMessage'],
    // 定义变量
    data() {
        return { formLabelWidth: '20%' };
    },
    methods: {
        // 关闭窗口之前需要调用的方法
        messageDialogClose() {
            this.$emit('messageDialogClose');
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
</style>
